export default __webpack_public_path__ + "static/media/quickAddHover.7ff6630c.svg";